import { useEffect } from "react";
import { createUseStyles } from "react-jss";
import Checkbox from "../../refresh/inputs/Checkbox";
import Label from "../../refresh/Label";
import { useMediaSelector } from "../../refresh/selectors/MediaSelector";
import styles from "../types/sharedStyles";

const useStyles = createUseStyles({ ...styles });

const AudioElement = ({ value, onChange }) => {
  const [media, getMedia] = useMediaSelector(value ?? {});
  const classes = useStyles();

  useEffect(() => {
    if (media.id) {
      onChange({ clip: { id: media.id, name: media.title } });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [media.id]);

  return (
    <>
      <Label name="Audio clip" required>
        <div className={classes.genericSelector}>
          <p>{value.clip?.name || "Select an audio clip"}</p>
          <button onClick={() => getMedia([3])}>Select from CMS</button>
        </div>
      </Label>
      <Checkbox
        value={value.autoplay}
        onChange={autoplay => onChange({ autoplay })}
      >
        Autoplay audio
      </Checkbox>
    </>
  );
};

export default AudioElement;
